/** All portal page changes, including browser back/forward, start at the top. */
export function portalScrollBehavior() {
    return {left: 0, top: 0};
}

/** Run after the outgoing page animation, when the new page actually exists. */
export function scrollPortalToTop() {
    window.scrollTo({left: 0, top: 0, behavior: 'instant'});
}

/** Share the browser history instead of pushing a new fixed "back" destination. */
export function goPortalBack(router, fallback = {name: 'portal-dashboard'}) {
    if (router.options.history.state.back) {
        router.back();
    } else {
        router.replace(fallback);
    }
}
